import React from 'react'
import styles from './styles.module.scss'
import Image from 'next/image'
import Link from 'next/link'
import { listRoute } from 'src/consts'
import { useAppIntl } from 'src/i18n'
import ListAuthor from 'src/components/ListAuthor'
import { ListTags } from '../ListTags'

interface ListProps {
  data?: { [key: string]: any }
  activeTags?: string[]
}

export const ListEntries = ({ data, activeTags = [] }: ListProps) => {
  const intl = useAppIntl()
  if (!data) {
    return
  }

  const flatData = Object.values(data).flat()

  const filteredData = activeTags.length
    ? flatData.filter(item =>
        activeTags.every(activeTag =>
          item.tags?.data?.some(tag => tag.attributes.description === activeTag)
        )
      )
    : flatData

  const isWithinAWeek = (publishedAt: string) => {
    const publicationDate: Date = new Date(publishedAt)
    const currentDate: Date = new Date()
    const differenceInMilliseconds: number =
      currentDate.getTime() - publicationDate.getTime()
    const millisecondsInWeek: number = 7 * 24 * 60 * 60 * 1000 // 7 days in milliseconds
    return differenceInMilliseconds <= millisecondsInWeek
  }

  return (
    <section className={styles.list}>
      {filteredData.map((item: any, index: number) => (
        <Link key={index} href={listRoute({ slug: item.slug })} passHref>
          <article className={styles.toplistContainer}>
            <div className={styles.contentContainer}>
              <div className={styles.iconsContainer}>
                {isWithinAWeek(item.publishedAt) && (
                  <div className={styles.newListIcon}>
                    <p>{intl.t('toplist.listEntries.new')}</p>
                  </div>
                )}
                <div className={styles.images}>
                  <Image
                    src={
                      item.list_index?.data?.attributes?.url ||
                      '/default-image.png'
                    }
                    alt={
                      item.list_index?.image?.data?.attributes
                        ?.alternativeText || 'Category icon'
                    }
                    width={24}
                    height={24}
                  />
                </div>
                <h2 className={styles.title}>{item.title}</h2>
              </div>
              <p className={styles.info}>{item.shortPreview}</p>
              <div className={styles.lowerContent}>
                <ListAuthor
                  authorData={{
                    authorSlug: item.author?.data?.attributes.slug,
                    authorImage:
                      item.author?.data?.attributes?.image?.data?.attributes
                        .url,
                    authorFullName: item.author?.data?.attributes?.fullName,
                    createdAt: item.publishedAt,
                  }}
                />
                <div className={styles.tags}>
                  {item.tags?.data?.map((tag: any, tagIndex: number) => (
                    <ListTags
                      backgroundColor='#1D1D1D'
                      tags={tag}
                      key={tagIndex}
                    />
                  ))}
                </div>
              </div>
            </div>
            <div className={styles.imgContainer}>
              <Image
                src={
                  item.mainImage?.data?.attributes?.url || '/default-image.png'
                } // Provide a fallback image URL if needed
                alt={
                  item.mainImage?.data?.attributes?.alternativeText ||
                  'Default Image'
                }
                className={styles.img}
                objectFit='cover'
                layout='fill'
              />
            </div>
          </article>
        </Link>
      ))}
    </section>
  )
}
